const Endpoint = {
    LOAD_AUTOCLOSE: '/viiu/autopilot/load',
    SAVE_AUTOCLOSE: '/viiu/autopilot/save',
    LOAD_COMPONENT_MUTING: '/viiu/component-muting/load',
    LOAD_COMPONENT_MUTING_BY_ID: '/viiu/component-muting/load-by-id',
    CREATE_COMPONENT_MUTING: '/viiu/component-muting/create',
    UPDATE_COMPONENT_MUTING: '/viiu/component-muting/update',
    RESUME_COMPONENT_MUTING: '/viiu/component-muting/resume',
    DELETE_COMPONENT_MUTING: '/viiu/component-muting/delete',
    ADD_ALARMS_PORTLET_WHEN_NOT_AVAILABLE: '/viiu/component-muting/add-alarms-portlet-when-not-available',
    LOAD_FILTER_OPTIONS: '/viiu/component-muting/load-component-filter-options',
};
export default Endpoint;
